/** Tag nhân viên (auth menu Tag nhân viên) — dùng lọc picker, không mở màn. */
export const TAG_NHAN_VIEN_PERMISSION_CODES = {
  /** NVKD: phụ trách KH, người bán, người nhận đặt/trả… */
  WEB_BH_TAG_NHAN_VIEN_KINH_DOANH: 'WEB_BH_TAG_NHAN_VIEN_KINH_DOANH',
  /** KTV: chọn kỹ thuật viên trên yêu cầu sửa chữa */
  WEB_BH_TAG_NHAN_VIEN_KY_THUAT: 'WEB_BH_TAG_NHAN_VIEN_KY_THUAT',
} as const

export type TagNhanVienPermissionCode =
  (typeof TAG_NHAN_VIEN_PERMISSION_CODES)[keyof typeof TAG_NHAN_VIEN_PERMISSION_CODES]
